export default __webpack_public_path__ + "static/media/isotipo.9dd5e412.svg";